export class GroupPayorList {
    id: string="00000000-0000-0000-0000-000000000000";
    agencyId: string | null;
    groupLid: string;
    payorName: string;
    billingFullName: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zip: string;
    phoneNumber: string;
    defaultBillType: string;
    payorId: string;
    i837PInsTypeLid: string | null;
    stateFormat: string;
    payorEmail: string;
    groupName: string;
    atypical: boolean;
    icd10: string;
    isIcd10FromClient: boolean | null;
    waiverFlag: boolean;
    description:string;
    payerInitialLid: string | null;
  
    statusLid:any;

}
export class GroupPayorCompanyMappingBO {
    id: string;
    groupPayorId:string;
    companyId: string;
    providerNo: string;
    companyFEIN: string;
    claim_Filling_Ind: string;
    taxCode_MANo: string;
    taxCode_MCNo: string;
}
export class getMappedCompanyBO {
    id: string;
    companyId: string;
    groupPayorId: string;
    companyName: string;
    providerNo: string;
    companyFEIN: string;
    claim_Filling_Ind: string;
    billto_Name: string;
    billto_Street: string;
    billto_City: string;
    billto_State: string;
    billto_zipcode: string;
    statusLid: string;
    statusValue: string;
    taxCode_MANo: string;
    taxCode_MCNo: string;
}
export class payorDropDownBO {
    label: string;
    value: string;
}
export class WhereCondition {
    field: string="payorName";
    value: string="";
    operator: string="startswith";
    orderNo: number=1;
    predicate: string="and";
    type: string="string";
    matchCase:boolean=false;
}
export class GetGroupPayorBO {
    SearchText: string ; 
    SearchColumn:string;
    orderColumn: string;
    orderType: string;
    pageitem: number;
    currentpageno: number;
    AgencyId: string;
    conitionBO: WhereCondition[];
}
export class sortingObj
{
    itemperpage : number =20;
    currentPgNo : number = 1;
    shortcolumn : string = "payorName" ;
    shortType : string = 'asc';
}
export class GetListBO {
    orderColumn: string = "payorName";
    orderType: string= "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    agencyID: string;
    field: string = "payorName";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
    type:string="string";
    statusLid:string;
}
export class functionpermission {
    grouppayorcreate: boolean = true;
    grouppayordelete: boolean = true;
    grouppayorupdate: boolean = true;
  
  }

  export class columnWidth {
    column: string = "";
    width: number = 0;
}

export class ColumnChangeBO {
    id: string;
    userid: string;
    agencyId: string;
    column: string
}